module.exports = __webpack_public_path__ + "static/media/Car_calligraphy_4.30812d67.jpg";